import React from "react"
import { Button, Form, Table } from "react-bootstrap"
import { Formik, FieldArray } from "formik"
import _ from "lodash"

import { formatPercentage } from "@/helpers/number"

import SingleSelect from "./input/SingleSelect"
import HiddenInput from "./HiddenInput"

const filteredOperatorOptions = (operators, appointments) =>
  _.reject(operators, (o) => _.find(appointments, ["operator.id", o.value]))

const newAppointment = ({ operator }) => ({
  operator,
  percentageAssignment: 0,
  accepted: false,
  main: false,
})

const OperatorPercentageAssignmentForm = ({ product }): JSX.Element => (
  <div className="d-flex flex-column gap-2">
    <p className="mb-0">
      Manage additional assigned operators on this tour, along with their percentage allocation.
    </p>
    {/* TODO Implement validations */}
    <Formik
      initialValues={{
        appointments: product.appointments,
        newOperatorId: null,
      }}
      onSubmit={() => undefined}
    >
      {({ values, setFieldValue }) => (
        <FieldArray
          name="appointments"
          render={(arrayHelpers) => (
            <>
              <Table>
                <thead>
                  <tr>
                    <th>Operator</th>
                    <th>Assignment</th>
                    <th>Accepted</th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  {values.appointments.map((appointment, index) => (
                    <tr key={appointment.operator.id}>
                      <td className="text-nowrap">
                        <HiddenInput
                          name="onboarding_contracting_operator_percentage_assignment_form[appointments][][operator_id]"
                          value={appointment.operator.id}
                        />
                        {appointment.main
                          ? `${appointment.operator.name} (main)`
                          : appointment.operator.name}
                      </td>
                      <td>
                        <Form.Control
                          name="onboarding_contracting_operator_percentage_assignment_form[appointments][][percentage_assignment]"
                          value={formatPercentage(appointment.percentageAssignment / 100.0)}
                          onChange={(e) =>
                            setFieldValue(
                              `appointments[${index}][percentageAssignment]`,
                              parseFloat(e.target.value)
                            )
                          }
                        />
                      </td>
                      <td>{appointment.accepted ? "Yes" : "No"}</td>
                      <td>
                        <Button
                          onClick={() => arrayHelpers.remove(index)}
                          disabled={appointment.main}
                          variant="danger"
                        >
                          <i className="fas fa-trash" />
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <div className="d-flex justify-content-between gap-2">
                <SingleSelect
                  name="new_operator"
                  label=""
                  placeholder="Available operators"
                  options={filteredOperatorOptions(product.availableOperators, values.appointments)}
                  onChange={(e) => setFieldValue("newOperatorId", e.target.value)}
                  value={values.newOperatorId}
                />
                <div>
                  <Button
                    onClick={() => {
                      const operatorOption = _.find(product.availableOperators, [
                        "value",
                        values.newOperatorId,
                      ])

                      arrayHelpers.push(
                        newAppointment({
                          operator: { id: operatorOption.value, name: operatorOption.label },
                        })
                      )

                      setFieldValue("newOperatorId", null)
                    }}
                    variant="outline-primary"
                    disabled={_.isNull(values.newOperatorId)}
                  >
                    <i className="fas fa-plus me-2" />
                    Add Operator
                  </Button>
                </div>
              </div>
            </>
          )}
        />
      )}
    </Formik>
  </div>
)

export default OperatorPercentageAssignmentForm
